/**
 * TrainingsFilters
 *
 * Filter by status and required-only. FilterMultiSelect for status; Checkbox for required-only.
 * PHI-safe: no patient data; operational training filters only.
 */

import { Checkbox, Group } from '@mantine/core';
import { SearchInput } from '../../../components/SearchInput';
import { FilterMultiSelect } from '../../../components/FilterMultiSelect';
import type { TrainingsFilters as TrainingsFiltersType } from '../types';
import { TrainingStatusLabels } from '../types';

const statusOptions = Object.entries(TrainingStatusLabels).map(([value, label]) => ({ value, label }));

interface TrainingsFiltersProps {
  filters: TrainingsFiltersType;
  onChange: (filters: TrainingsFiltersType) => void;
}

export function TrainingsFilters({ filters, onChange }: TrainingsFiltersProps): JSX.Element {
  return (
    <Group gap="md" align="center" wrap="wrap" flex="1">
      <SearchInput
        placeholder="Search trainings..."
        value={filters.search}
        onChange={(e) => onChange({ ...filters, search: e.currentTarget.value })}
        w={280}
      />
      <FilterMultiSelect
        allLabel="All statuses"
        data={statusOptions}
        value={filters.status}
        onChange={(v) => onChange({ ...filters, status: v as TrainingsFiltersType['status'] })}
        w={220}
      />
      <Checkbox
        label="Required only"
        checked={filters.requiredOnly}
        onChange={(e) => onChange({ ...filters, requiredOnly: e.currentTarget.checked })}
      />
    </Group>
  );
}
